import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Input from "app/pages/.shared/form/Input.jsx";
import Select from "app/pages/.shared/form/Select.jsx";
import "./payment-identity-fieldset.scss";
import { CIVILITY } from "app/constants";

class PaymentIdentityFieldset extends React.PureComponent {
	constructor() {
		super();
		this.handleGenderChange = this.handleGenderChange.bind(this);
	}

	handleGenderChange(event) {
		// hack : On est obliger de passer par une fonction handleGenderChange intermédiaire pour corriger un
		// problème sur Firefox sur les brands UG LS et CD où l'on ne pouvait pas sélectionner la civilité
		// de chaque passager
		// Ceci a résolu le pb mais je ne sais pas pourquoi XD
		if (typeof onBlur === "function") {
			this.props.onBlur(event);
		}
	}

	render() {
		const { fields = {}, id, onBlur } = this.props;
		return (
			<div className="payment-identity">
				<div className="payment-identity__group">
					<div className="payment-identity__gender payment-identity__gender--select">
						<Select
							isRequired={true}
							name={`${id}-gender`}
							id={`${id}-gender`}
							field={fields.gender}
							onChange={this.handleGenderChange}
							label={<FormattedMessage id="identity.gender.label" />}
							data-cy={`payment-gender-${id}`}
						>
							<option />
							{[CIVILITY.MALE, CIVILITY.FEMALE].map(gender => (
								<FormattedMessage
									key={gender}
									id={`general.gender.${gender.toLowerCase()}`}
								>
									{message => (
										<option key={gender} value={gender}>
											{message}
										</option>
									)}
								</FormattedMessage>
							))}
						</Select>
					</div>
				</div>
				<div className="payment-identity__group">
					<div className="payment-identity__lastname payment-identity__input">
						<Input
							isRequired={true}
							field={fields.lastName}
							label={<FormattedMessage id="identity.lastname.label.full" />}
							name={`${id}-lastname`}
							id={`${id}-lastname`}
							maxLength="30"
							onBlur={onBlur}
							data-cy={`payment-lastname-${id}`}
						/>
					</div>

					<div className="payment-identity__firstname payment-identity__input">
						<Input
							isRequired={true}
							field={fields.firstName}
							label={<FormattedMessage id="identity.firstname.label" />}
							name={`${id}-firstname`}
							id={`${id}-firstname`}
							maxLength="30"
							onBlur={onBlur}
							data-cy={`payment-firstname-${id}`}
						/>
					</div>
				</div>
			</div>
		);
	}
}

PaymentIdentityFieldset.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	fields: PropTypes.object,
	onBlur: PropTypes.func,
};

export default PaymentIdentityFieldset;
